import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../components/HomePage.vue'
import GuidePage from '../views/GuidePage.vue'
import HistoryPage from '../views/HistoryPage.vue'
import StartAssessmentPage from '../views/StartAssessmentPage.vue'
import BasicInfoPage from '../views/BasicInfoPage.vue'
import QuestionnairePage from '../views/QuestionnairePage.vue'
import CalculatingPage from '../views/CalculatingPage.vue'

// 动物测试相关页面
import AnimalResultPage from '../views/AnimalResultPage.vue'
import AnimalDetailPage from '../views/AnimalDetailPage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/guide',
    name: 'Guide',
    component: GuidePage
  },
  {
    path: '/history',
    name: 'History',
    component: HistoryPage
  },
  {
    path: '/assessment/start',
    name: 'StartAssessment',
    component: StartAssessmentPage
  },
  {
    path: '/assessment/info',
    name: 'BasicInfo',
    component: BasicInfoPage
  },
  {
    path: '/assessment/questions',
    name: 'Questionnaire',
    component: QuestionnairePage
  },
  {
    path: '/assessment/calculating',
    name: 'Calculating',
    component: CalculatingPage
  },
  // 动物测试结果页
  {
    path: '/animal-result',
    name: 'AnimalResult',
    component: AnimalResultPage
  },
  // 动物详情页
  {
    path: '/animal-detail/:name',
    name: 'AnimalDetail',
    component: AnimalDetailPage,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router

